import type { ShouldRevalidateFunction } from 'react-router';

/**
 * Canonical RR7 single-fetch leaf-route revalidation policy.
 *
 * A leaf route mounted under a layout that SKIPS revalidation — `_app.tsx` on
 * same-path search-only changes (pagination / filtering), or the `/articles`
 * and `/professional/<seg>` layouts on same-subtree navigation — is dropped
 * from the single-fetch `_routes` scope on a same-URL revalidation unless it
 * declares its own policy. The server then omits the leaf from the `.data`
 * response and the client throws `No result found for routeId "<leaf>"`. Every
 * paginated or filtered leaf under such a layout needs this policy (the articles
 * routes, the professional tabs, and the professionals directory).
 *
 * Opt every such leaf in explicitly: revalidate on GET navigation — pagination
 * and filter changes need fresh leaf data anyway — and skip on form actions,
 * which post elsewhere and must not re-run the leaf loader.
 */
export const shouldRevalidateLeaf: ShouldRevalidateFunction = ({
    formAction,
}) => {
    if (formAction) {
        return false;
    }
    return true;
};
